import React, { useState } from "react";
import ManagerDashboardWapper from "../../../layout/wrapper/ManagerDashboardWapper";
import {
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import styles from "../../../styles/pages/user/managerdashboard/manager-dashborad-assignaccount.module.scss";
import ManagerassignedaccountCard from "../../../components/ManagerassignedaccountCard/ManagerassignedaccountCard";
import ManagerassignFilter from "../../../components/ManagerassignFilter/ManagerassignFilter";
import ManagerSummaryCard from "../../../components/ManagerSummaryCard/ManagerSummaryCard";
import memberImg from "../../../public/assets/images/memberImg.png";
import useInfinitePost from "../../../hooks/api/useInfiniteFetch";
import useFetch, { usePost } from "../../../hooks/api/useFetch";
import ApiLoader from "../../../components/Loaders/ApiLoader";

export default function AssignedAccounts() {
  const [date, setDate] = useState({ startDate: "", endDate: "", type: "" });
  console.warn("assigned", date);

  //   const assignCardLoop = [
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 0,
  //     },
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 0,
  //     },
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 0,
  //     },
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 0,
  //     },
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 0,
  //     },
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 0,
  //     },
  //     {
  //       avatar: `${memberImg}`,
  //       title: "BoardTube",
  //       link: "http://www.boardtubesubmission.com/",
  //       name: "Gregory Moss",
  //       email: "gregmos@gmail.com",
  //       cardStatus: 1,
  //     },
  //   ];

  // const listItemLoop = [
  //   {
  //     listName: "Pending Review",
  //     videoCount: "580",
  //   },
  //   {
  //     listName: "Approved submissions",
  //     videoCount: "420",
  //   },
  //   {
  //     listName: "Website Only submissions",
  //     videoCount: "10",
  //   },
  //   {
  //     listName: "Rejected submissions",
  //     videoCount: "150",
  //   },
  //   {
  //     listName: "Duplicated submissions",
  //     videoCount: "10",
  //   },
  // ];

  const getDataFromChild = (data) => {
    if (data.startDate && data.endDate) {
      setDate(data);
    } else {
      setSearch(data);
    }
  };

  // data load assigned
  const {
    data: assignedData,
    isSuccess,
    isError,
    isLoading,
    refetch: refetchAssigned,
    hasNextPage,
    isFetching,
    fetchNextPage,
  } = useInfinitePost(
    ["assigned", date?.startDate, date?.endDate],
    `manager/assigned-users`,
    { from: date?.startDate, to: date?.endDate }
  );

  console.warn("assignedData", assignedData);

  // data load assigned

  // submission data
  const {
    data: submissionsData,
    isError: submissionsError,
    isLoading: submissionsLoading,
    isSuccess: submissionsSuccess,
  } = usePost(["submissions"], "manager/submissions");
  console.warn(submissionsData?.data?.data);

  // submission data

  return (
    <ManagerDashboardWapper>
      <ApiLoader loading={isLoading || isFetching} />
      <Paper elevation={0} className={styles.pageassignAccount}>
        <PerfectScrollbar className={styles.assignScroll}>
          <Stack
            direction={"row"}
            alignItems={"flex-start"}
            flexWrap={"wrap"}
            className={styles.assignwrapper}
          >
            <Box className={`${styles.leftBox} ${styles.colBox}`}>
              <ManagerassignFilter
                getDataFromChild={getDataFromChild}
                refetchAssigned={refetchAssigned}
              />
            </Box>
            <Box className={`${styles.midBox} ${styles.colBox}`}>
              <Box className={`${styles.innerSearch}`}>
                {isLoading ? (
                  ""
                ) : isSuccess ? (
                  <ManagerassignedaccountCard
                    isLoading={isLoading}
                    assignedData={assignedData}
                  />
                ) : (
                  ""
                )}

                {hasNextPage ? (
                  <Box className={styles.loadMore}>
                    <Button
                      onClick={fetchNextPage}
                      className={styles.viewmoreAssignCard}
                    >
                      View More
                    </Button>
                  </Box>
                ) : null}
              </Box>
            </Box>
            <Box className={`${styles.rightBox} ${styles.colBox}`}>
              <ManagerSummaryCard videoTitle={"Submissions Reviewing Summary"}>
                <List disablePadding>
                  <ListItem disablePadding>
                    <Typography variant="body1">Pending Review</Typography>
                    <Typography variant="caption">
                      {submissionsData?.data?.data?.submissions?.pending}
                    </Typography>
                  </ListItem>
                  <ListItem disablePadding>
                    <Typography variant="body1">
                      Approved submissions
                    </Typography>
                    <Typography variant="caption">
                      {submissionsData?.data?.data?.reviewed_videos?.approved}
                    </Typography>
                  </ListItem>
                  <ListItem disablePadding>
                    <Typography variant="body1">
                      Website Only submissions
                    </Typography>
                    <Typography variant="caption">
                      {
                        submissionsData?.data?.data?.reviewed_videos
                          ?.website_only
                      }
                    </Typography>
                  </ListItem>
                  <ListItem disablePadding>
                    <Typography variant="body1">
                      Rejected submissions
                    </Typography>
                    <Typography variant="caption">
                      {submissionsData?.data?.data?.reviewed_videos?.rejected}
                    </Typography>
                  </ListItem>
                  <ListItem disablePadding>
                    <Typography variant="body1">
                      Duplicated submissions
                    </Typography>
                    <Typography variant="caption">
                      {submissionsData?.data?.data?.submissions?.duplicate}
                    </Typography>
                  </ListItem>
                </List>
              </ManagerSummaryCard>
            </Box>
          </Stack>
        </PerfectScrollbar>
      </Paper>
    </ManagerDashboardWapper>
  );
}
